// Regras de horas, as mesmas no celular do funcionario e na tela de aprovacao.
// Horas pagas = tempo total (do clock in ao clock out) menos o almoco.

export const LUNCH_OPTIONS = [0, 15, 30, 45, 60];

export function fmtTime(iso) {
  if (!iso) return "-";
  return new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

export function fmtDur(mins) {
  if (mins >= 24 * 60) {
    const d = Math.floor(mins / 1440);
    const h = Math.floor((mins % 1440) / 60);
    return `${d}d ${h}h`;
  }
  return `${Math.floor(mins / 60)}h ${String(mins % 60).padStart(2, "0")}m`;
}

// Segundos de almoco a descontar. Vale o almoco escolhido (lunch_minutes). Em turnos
// antigos, vale o intervalo marcado pelos botoes de iniciar/terminar almoco.
export function lunchSecondsOf(s, endMs) {
  if (typeof s.lunch_minutes === "number") return s.lunch_minutes * 60;
  if (s.lunch_start) {
    const ls = Date.parse(s.lunch_start);
    const le = s.lunch_end ? Date.parse(s.lunch_end) : endMs;
    return Math.max(0, (Math.min(le, endMs) - ls) / 1000);
  }
  return 0;
}

export function grossSecondsOf(s, nowMs) {
  const start = Date.parse(s.clock_in);
  const end = s.clock_out ? Date.parse(s.clock_out) : nowMs;
  return Math.max(0, Math.floor((end - start) / 1000));
}

export function paidSecondsOf(s, nowMs) {
  const end = s.clock_out ? Date.parse(s.clock_out) : nowMs;
  return Math.max(0, Math.floor(grossSecondsOf(s, nowMs) - lunchSecondsOf(s, end)));
}

export function paidMinutesOf(s, nowMs) {
  return Math.round(paidSecondsOf(s, nowMs) / 60);
}

export function grossMinutesOf(s, nowMs) {
  return Math.round(grossSecondsOf(s, nowMs) / 60);
}

export function lunchMinutesOf(s) {
  const end = s.clock_out ? Date.parse(s.clock_out) : Date.now();
  return Math.round(lunchSecondsOf(s, end) / 60);
}

// "active" (ainda trabalhando), "pending" (aguardando aprovacao), "approved" ou "rejected".
export function statusOf(s) {
  if (!s.clock_out) return "active";
  if (s.approved === true) return "approved";
  if (s.approved === false) return "rejected";
  return "pending";
}

// O ultimo almoco escolhido vira o padrao da proxima vez.
export function getLastLunch() {
  try {
    const raw = localStorage.getItem("ss_last_lunch");
    if (raw === null) return 30;
    const v = Number(raw);
    return Number.isFinite(v) && v >= 0 && v <= 300 ? v : 30;
  } catch (e) {
    return 30;
  }
}

export function saveLastLunch(v) {
  try {
    localStorage.setItem("ss_last_lunch", String(v));
  } catch (e) {
    // sem acesso ao armazenamento: tudo bem
  }
}

// Conversao entre o horario do servidor (ISO) e o campo de data e hora do celular.
export function toLocalInput(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function fromLocalInput(value) {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}
